<div class="page-overlay" *ngIf="isBusy">
  <div class="center">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>
<mat-dialog-content class="mat-typography">
  
    <h1 mat-dialog-title>Projekt löschen</h1>
    
    <p>Sind Sie sich sicher, dass sie das projekt "{{csProject.projectName}}" löschen möchten?</p>
     
    <mat-error *ngIf="error">{{error}}</mat-error>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Nein</button>
    <button mat-button cdkFocusInitial (click)="deleteProject()">Ja</button>
  </mat-dialog-actions>
